module.exports = __webpack_public_path__ + "assets/img/b7d092d.b7d092d9.jpg";